import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { statusTextTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: 'solid rgba(0, 0, 0, .2) 1px',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    featureText: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
    },
    releaseDateText: {
      paddingTop: theme.spacing(2),
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  }),
);

const GreenTypography = withStyles({
  root: {
    color: 'rgba(104, 203, 66, 1.0)',
  },
})(Typography);

export default function ComingFeatureGreenItem(props: any) {
  const { featureText, releaseYear = '2025' } = props;
  const classes = useStyles(statusTextTheme);
  return (
    <Grid container item xs={12} className={classes.root}>
      <Grid item xs={8}>
        <GreenTypography variant="h5" className={classes.featureText}>
          {featureText}
        </GreenTypography>
      </Grid>
      <Grid item xs={4}>
        <GreenTypography variant="h5" className={classes.releaseDateText}>
          COMING IN {releaseYear}
        </GreenTypography>
      </Grid>
    </Grid>
  );
}
